import { token } from '@atlaskit/tokens';

export const panel: {
	display: string; // DEBUGGING
	borderWidth: 'var(--ds-border-width)';
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: 'var(--ds-radius-small)';
	borderStyle: string;
	borderColor: 'var(--ds-border)';
	borderImage: string;
} = {
	display: 'block', // DEBUGGING
	borderWidth: token('border.width'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	borderStyle: 'solid',
	borderColor: token('color.border'),
	borderImage: 'initial',
};

export const panelHeader: {
	display: string; // DEBUGGING
	backgroundColor: 'var(--ds-background-accent-gray-subtlest)';
	minWidth: string;
	padding: 'var(--ds-space-100)';
	font: 'var(--ds-font-body-large)';
} = {
	display: 'block', // DEBUGGING
	backgroundColor: token('color.background.accent.gray.subtlest'),
	minWidth: '128px',
	padding: token('space.100'),
	font: token('font.body.large'),
};

export const panelBody: {
	display: string;
	minWidth: string;
	borderWidth: string;
	borderStyle: string;
	borderColor: 'var(--ds-border)';
	padding: 'var(--ds-space-100)';
} = {
	display: 'block', // DEBUGGING
	minWidth: '128px',
	borderWidth: `${token('border.width')} 0px 0px 0px`,
	borderStyle: 'solid',
	borderColor: token('color.border'),
	padding: token('space.100'),
};

export const panelHeaderExcerpt: {
	color: 'var(--ds-text-subtlest)';
	paddingLeft: 'var(--ds-space-050)';
} = {
	color: token('color.text.subtlest'),
	paddingLeft: token('space.050'),
};
